module.exports = __webpack_public_path__ + "img/what-web-front-end-title.fbc194d2.png";